import { render, staticRenderFns } from "./commissions.vue?vue&type=template&id=20282560&scoped=true"
import script from "./commissions.vue?vue&type=script&lang=js"
export * from "./commissions.vue?vue&type=script&lang=js"
import style0 from "./commissions.vue?vue&type=style&index=0&id=20282560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20282560",
  null
  
)

export default component.exports